// Columnas de la grilla de Inscripciones.
// Requerimiento cliente (Módulo 6):
//   - Agregar "Año de la materia" (subjectYear <- subject.cycle en el back).
//   - Forma de pago: mostrar claramente cuotas + monto.
//     NOTA: el back hoy envía `paymentMethod` y `paymentOption`. Si se necesita
//     mostrar "N cuotas: $X" se debe extender el backend para devolver
//     installments/totalAmount en este mismo payload. Por ahora se muestra
//     lo disponible.
//   - Quitar "EDITAR" de las acciones.
//   - Agregar acciones "BAJA" y "ELIMINAR" (baja lógica).
export const columnsDataInscriptions = [
  {
    Header: 'ID',
    accessor: 'id',
  },
  {
    Header: 'NOMBRE',
    accessor: 'studentName',
  },
  {
    Header: 'APELLIDO',
    accessor: 'studentLastname',
  },
  {
    Header: 'DOCUMENTO',
    accessor: 'documentNumber',
  },
  {
    Header: 'MATERIA',
    accessor: 'subjectName',
  },
  {
    // "Año de la materia" (1°, 2°, ...). Fuente: subject.cycle (back: `subjectYear`).
    Header: 'AÑO',
    accessor: 'subjectYear',
    computedValue: (rowData) => (rowData.subjectYear ? `${rowData.subjectYear}°` : '-'),
  },
  {
    Header: 'FECHA INSCRIPCIÓN',
    accessor: 'inscriptionDate',
    computedValue: (rowData) =>
      rowData.inscriptionDate
        ? new Date(rowData.inscriptionDate).toLocaleDateString('es-ES')
        : '-',
  },
  {
    Header: 'FECHA DE BAJA',
    accessor: 'dischargeDate',
    computedValue: (rowData) =>
      rowData.dischargeDate
        ? new Date(rowData.dischargeDate).toLocaleDateString('es-ES')
        : '-',
  },
  {
    // Forma de pago. Se muestran cuotas + monto cuando estén disponibles en el payload.
    // TODO backend: incluir `installmentsCount` y `installmentAmount` en el listado
    // para poder armar "N cuotas: $X" de forma homogénea.
    Header: 'FORMA DE PAGO',
    accessor: 'paymentMethod',
    computedValue: (rowData) => {
      const count = rowData.installmentsCount;
      const amount = rowData.installmentAmount;
      if (count && amount) {
        const formatted = Number(amount).toLocaleString('es-UY', {
          style: 'currency',
          currency: 'UYU',
        });
        return `${count} ${count === 1 ? 'cuota' : 'cuotas'}: ${formatted}`;
      }
      return rowData.paymentMethod || '-';
    },
  },
  {
    Header: 'ESTADO',
    accessor: 'status',
    computedValue: (rowData) => {
      switch (rowData.status) {
        case 'active':
          return 'Activa';
        case 'inactive':
          return 'Baja';
        case 'cancelled':
          return 'Eliminada';
        case 'completed':
          return 'Completada';
        case 'pending':
          return 'Pendiente';
        default:
          return rowData.status || '-';
      }
    },
  },
];
